import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, withDefaults } from "vue";
import { useRoute, useRouter } from "vue-router";
import { isEmptyOrWhiteSpace } from "@/utils/helper";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
    title: { default: "" },
    alwaysShowBack: { type: Boolean, default: false },
    actionMenus: { default: () => [] }
  },
  emits: ["menu-command"],
  setup(__props: any, { emit: emits }) {

const props = __props as { title: string, alwaysShowBack: boolean, actionMenus: Array<any> }





const route = useRoute();
const router = useRouter();

const showPopover = ref(false);
const emptyTitle = isEmptyOrWhiteSpace(props.title);

const navTitle = ref("");

const visibleLeftArrow = ref(true);
visibleLeftArrow.value = route.name !== "patent" && route.meta.nav !== false;

if (emptyTitle) {
  navTitle.value = route.meta.title as string ?? "";
} else {
  navTitle.value = props.title ?? "";
}

function onClickLeft() {
  router.back();
}

function onMenuSelect(item: any, index: number) {
  emits("menu-command", item, index);
}

watch(() => route.name, () => {
  visibleLeftArrow.value = route.name !== "patent" && route.meta.nav !== false;
  if (emptyTitle) {
    navTitle.value = route.meta.title as string;
  }
});

watch(() => props.title, (newValue: string) => {
  navTitle.value = newValue;
});


return (_ctx: any,_cache: any) => {
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanPopover = _resolveComponent("VanPopover")!
  const _component_VanNavBar = _resolveComponent("VanNavBar")!

  return (_openBlock(), _createBlock(_component_VanNavBar, {
    title: navTitle.value,
    "left-arrow": __props.alwaysShowBack||visibleLeftArrow.value,
    onClickLeft: onClickLeft
  }, _createSlots({ _: 2 }, [
    (__props.actionMenus&&__props.actionMenus.length>0)
      ? {
          name: "right",
          fn: _withCtx(() => [
            _createVNode(_component_VanPopover, {
              show: showPopover.value,
              "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showPopover).value = $event)),
              actions: __props.actionMenus,
              placement: "bottom-end",
              onSelect: onMenuSelect
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_VanIcon, { name: "ellipsis" })
              ]),
              _: 1
            }, 8, ["show", "actions"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title", "left-arrow"]))
}
}

})